import { FC } from "react";
import { useSelector } from "react-redux";

import { ProfileLinkButton, ProfileModalContent, ProfileModalName, ProfileModalWrapper } from "./styledComponents";
import { getCurrentUser, getWindowWidth, setCurrentUser } from "../../../features/basic/reducers/basicReducer";
import i18n from "../../../i18n/config";
import { MenuArrowIcon } from "../table/rowIcons";
import { getApiRegistry } from "../../state/apiRegistry";
import { useTheme, useVariables } from "../../../features/context/CustomerContext";
import useCustomTranslation from "../../../features/hooks/CustomUseTranslation";
import { useAuth } from "react-oidc-context";

export interface UserProfileModalProps {
    show: boolean;
    languageSelection: boolean;
    setLanguageSelection: (show: boolean) => void;
}

const UserProfileModal: FC<UserProfileModalProps> = (props) => {
    const { t } = useCustomTranslation();
    const theme = useTheme();
    const variables = useVariables();

    const currentUser = useSelector(getCurrentUser);
    const windowWidth = useSelector(getWindowWidth);

    const auth = useAuth();

    if (!props.show) {
        return null;
    }

    function changeLanguage(e: string) {
        i18n.changeLanguage(e);
        props.setLanguageSelection(false);
        getApiRegistry().usersApi.changeLocale(e);
    }

    function logout() {
        auth.removeUser();
        setCurrentUser(undefined);
        auth.signoutRedirect({ id_token_hint: auth.user?.id_token });
        window.sessionStorage.removeItem("keycloakIdToken");
    }

    return (
        <ProfileModalWrapper>
            <ProfileModalContent>
                {(windowWidth <= 1355) && variables.headerMenuLinks &&
                    <> 
                    <ProfileModalName theme={theme}>{t("externalServices")}</ProfileModalName>
                        {variables.headerMenuLinks.map((button, index) => (!button.hideInDesktop &&
                        <ProfileLinkButton key={index} onClick={() => window.location.href = button.buttonLink}>{t(button.buttonTitle)}</ProfileLinkButton>))}
                    </>
                }
                <ProfileModalName theme={theme}>{props.languageSelection ? t("Choose language") : currentUser?.firstName + " " + currentUser?.lastName}
                </ProfileModalName>
                {props.languageSelection ?
                    variables.localizationLanguages && variables.localizationLanguages?.map(language => (
                        <ProfileLinkButton key={language.language} onClick={() => changeLanguage(language.languageAbbreviation)}>{t(language.language)}
                        </ProfileLinkButton>))
                    :
                    <>
                        {variables.localizationLanguages.length > 1 &&
                            <ProfileLinkButton onClick={() => props.setLanguageSelection(true)}>{t('Language, ' + i18n.language)}
                                <MenuArrowIcon />
                            </ProfileLinkButton>}
                        <ProfileLinkButton onClick={() => { window.location.href = variables.USER_SETTINGS_LINK ? variables.USER_SETTINGS_LINK : "" }}>{t("User settings")}
                            <MenuArrowIcon />
                        </ProfileLinkButton><br />
                        <ProfileLinkButton onClick={() => {
                            logout()
                        }}>{t("Logout")}
                            <MenuArrowIcon />
                        </ProfileLinkButton>
                    </>}
            </ProfileModalContent>
        </ProfileModalWrapper>
    )
}

export default UserProfileModal;